"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var MobilePromo_1 = require("@/pages/common/components/MobilePromo");
var mapStateToProps = function (state) { return (__assign({}, state.mobilepromo)); };
var mapDispatchToProps = function () { return ({}); };
var resultMobilePromo = function (props) {
    if (!props.isActive)
        return null;
    return (React.createElement("div", { className: "c-result__promo-item" },
        React.createElement(MobilePromo_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(resultMobilePromo);
